import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getInitials } from "../../../../libs/utils";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import { Link } from "react-router-dom";
import "../style.css";
import { useDispatch, useSelector } from "react-redux";
import { saveCommunityTemplate } from "../../../../store/actions/ask";
import { useSaveDotsFeedbackToast } from "../../../../customHooks";
import LoaderSimple from "../../../general/loader";

const CommunityTemplateBlock = ({
  index,
  templateName,
  templateCategory,
  templateAuthor,
  templateDate,
  // templateScore,
  templatePrice,
  templateDownloads,
  templateId
}) => {
  const dispatch = useDispatch();
  const saveCommunityTemplateState = useSelector(state => state.ask.saveCommunityTemplateState);
  const [clickedBlock, setClickedBlockIndex] = useState(null);
  const date = moment(templateDate);
  const formattedDate = date.format("DD MMM YYYY");

  useSaveDotsFeedbackToast(
    saveCommunityTemplateState, false, false
  );

  const saveDots = (index) => {
    setClickedBlockIndex(index);
    dispatch(saveCommunityTemplate( templateId));
  };

  return (
    <div className="singleBlockContainer">
      <div className="mainInfoBlock">
        <div className="roundAuthor">
          <span>
            {templateAuthor
              ? getInitials(templateAuthor)
              : "N/A"}{" "}
          </span>
        </div>
        <div className="templateInfoContainer">
          <p className="templateName">{templateName}</p>
          <p className="templateDescription"><FormattedMessage id={`ask.categories.${templateCategory}`} /></p>
          <p className="templateDescription">{`${templateAuthor} / ${formattedDate}`}</p>
          {/* temporary ignore score */}
          {/* <p className="templateScore">{templateScore}</p> */}
        </div>
        <div className="templateValueContainer">
          <p className="templatePrice">
            {templatePrice ? templatePrice : <FormattedMessage id="ask.pages.edit.communityTemplates.templatePriceFree" />}
          </p>
          <div className="priceDownloadContainer">
            <p className="templateDownloads">{templateDownloads} <FormattedMessage id="ask.pages.edit.communityTemplates.templateDownloads" /></p>
          </div>
        </div>
      </div>
      <div className="secondaryInfoBlock">
        <div className="icon-container">
          <Link to={`${"/community-template/"}${templateId}`}>
            <FontAwesomeIcon
              icon={["fas", "eye"]}
              style={{ fontSize: 16, color: "rgb(0, 144, 209)" }}
            />
          </Link>
        </div>
        <div className="icon-container">
          {saveCommunityTemplateState.isSavingCommunityTemplateDetails && clickedBlock === index ?
            <LoaderSimple />
            :
            <FontAwesomeIcon
              icon={["far", "arrow-to-bottom"]}
              style={{ fontSize: 16 }}
              onClick={() => saveDots(index)}
            />
          }
        </div>
      </div>
    </div>
  );
};

export default CommunityTemplateBlock;